import axios from 'axios';
import { getAuthorazieHeader } from './service';
import { url, endpoints } from './config';

// GET /credentials (list with optional filters)
export const getCredentialsList = async (query: any = {}) => {
  const headers = getAuthorazieHeader();

  try {
    const res = await axios.get(`${url}${endpoints.getCredentials}`, {
      headers,
      params: query, // supports ?type=...&env=...
    });

    return res.data?.data?.data || [];
  } catch (err) {
    console.error('API error:', err);
    return [];
  }
};

// GET /credentials/:id
export const getCredentialById = async (id: string) => {
  const headers = getAuthorazieHeader();

  const res = await axios.get(`${url}${endpoints.getCredentials}/${id}`, { headers });
  return res.data?.data || null;
};

// POST /credentials
export const createCredential = async (payload: any) => {
  const headers = getAuthorazieHeader();
  const res = await axios.post(`${url}${endpoints.getCredentials}`, payload, { headers });
  return res.data?.data;
};

// PUT /credentials/:id
export const updateCredential = async (id: string, payload: any) => {
  const headers = getAuthorazieHeader();
  const res = await axios.put(`${url}${endpoints.getCredentials}/${id}`, payload, { headers });
  return res.data?.data;
};

// PATCH /credentials/:id
export const patchCredential = async (id: string, payload: any) => {
  const headers = getAuthorazieHeader();
  const res = await axios.patch(`${url}${endpoints.getCredentials}/${id}`, payload, { headers });
  return res.data?.data;
};

// DELETE /credentials/:id (Soft Delete)
export const deleteCredential = async (id: string) => {
  const headers = getAuthorazieHeader();
  const res = await axios.delete(`${url}${endpoints.getCredentials}/${id}`, { headers });
  return res.data?.data;
};

// GET /credentials/:id/audit
export const getCredentialAudit = async (id: string) => {
  const headers = getAuthorazieHeader();
  const res = await axios.get(`${url}${endpoints.getCredentials}/${id}/audit`, { headers });
  return res.data?.data || [];
};
